/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  window?.utils?.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
    window.searchAutoComplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  window.collectionSidebarFilter.init();
  window.collectionSidebarDrawer.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll
  const {
    pathname
  } = location;

  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  const beforeResizeWidth = $(window).width();

  window.addEventListener('resize', () => {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        const currentScreenWidth = $(window).width();
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  function getAspectRatio(width, height) {
    const ratio = width / height;
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    const $iframe = $(iframe);
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  window.lazyframe('.lazyframe');

  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting
  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });
  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        ...(cartItem.itemKey
          ? { id: String(cartItem.itemKey) }
          : { line: cartItem.lineID }
        )
      },
      success(data) {
        const cartItemsArray = data.items;
        const $parentForm    = cartItem.parentCartForm;
        const $quantityInputs = $parentForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        const totalCartItems  = $parentForm.find('[data-variant-id]').length;
        let apiLineItem = null;
        if (cartItem.itemKey) {
          apiLineItem = cartItemsArray.find(i => String(i.key) === String(cartItem.itemKey)) || null;
        }
        if (!apiLineItem) {
          const lineIDIndex = cartItem.lineID - 1;
          apiLineItem = cartItemsArray[lineIDIndex] || null;
        }

        const apiLineItemQuantity = apiLineItem ? apiLineItem.quantity : 0;

        let initialQuantityTotal = 0;
        let apiQuantityTotal     = 0;

        if ($quantityInputs.length > 1) {
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val(), 10);
          });
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          initialQuantityTotal = parseInt($quantityInputs.val(), 10) || 0;
          apiQuantityTotal     = apiLineItemQuantity;
        }

        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          const itemsLeftText = apiQuantityTotal === 1
            ? window.PXUTheme.translation.one_item_left
            : window.PXUTheme.translation.items_left_text;

          $('.warning--quantity').remove();

          if (totalCartItems < cartItemsArray.length) {
            if ($parentForm.data('cart-form') === 'cart-template') {
              $parentForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            $parentForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            $parentForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }

        } else if ($parentForm.data('cart-form') === 'cart-template') {
          $parentForm.submit();
        } else {
          refreshCart(data);
        }
      },
      error(xhr) {
        let message = 'There was an error updating your cart. Please try again.';
        try {
          const response = JSON.parse(xhr.responseText);
          if (response.description) message = response.description;
          else if (response.message) message = response.message;
        } catch(e) { /* use default message */ }

        $('.warning--quantity').remove();
        cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`)
          .parent().after(`<p class="warning warning--quantity animated bounceIn">${message}</p>`);

        if (cartItem.$element) {
          cartItem.$element.find('[data-cart-quantity-input]').val(cartItem.$element.find('[data-cart-quantity-input]').attr('data-original-qty') || cartItem.quantity);
        }
      },
      complete() {
        if (cartItem.$element) {
          cartItem.$element.find('.js-change-quantity').removeClass('is-disabled');
        }
      }
    });
  }

  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function updateBundleQuantity(bundleId, newQty, $parentForm, $fallbackElement) {
    const updates = {};
    $('[data-cart-item][data-bundle-id="' + bundleId + '"]').each(function () {
      const itemKey = $(this).data('item-key');
      if (itemKey) updates[String(itemKey)] = newQty;
    });

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ updates }),
      success(updatedCart) {
        if ($parentForm.data('cart-form') === 'cart-template') {
          location.reload();
        } else {
          refreshCart(updatedCart);
        }
      },
      error() {
        updateCartItemQuantity({
          lineID:         $fallbackElement.data('line-id'),
          variantID:      $fallbackElement.data('variant-id'),
          quantity:       newQty,
          parentCartForm: $parentForm,
          totalDiscount:  $parentForm.data('total-discount'),
          $element:       $fallbackElement
        });
      },
      complete() {
        $('[data-cart-item][data-bundle-id="' + bundleId + '"]')
          .find('.js-change-quantity')
          .removeClass('is-disabled');
      }
    });
  }

  /* ===================================================================
     refreshCart — Section Rendering API
     ─────────────────────────────────────────
     Fetches server-rendered cart-drawer section HTML.
     No more JS HTML string building. Liquid is the
     single source of truth for cart drawer markup.
     =================================================================== */

    function refreshCart(cart) {
      if (cart) {
        var count = (typeof cart === 'object') ? cart.item_count : 0;
        $('.cart_count').text(count);

        if (count === 0) {
          $('.js-empty-cart__message').removeClass('hidden');
          $('[data-cart-form]').addClass('hidden');
        } else {
          $('.js-empty-cart__message').addClass('hidden');
          $('[data-cart-form]').removeClass('hidden');
        }
      }

      _fetchCartDrawerSection();
    }

    window.refreshCart = refreshCart;

    function _fetchCartDrawerSection() {
      fetch('/?sections=cart-drawer')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data['cart-drawer'];
          if (!html) return;

          var $fresh = $('<div>').html(html);
          var $freshInner = $fresh.find('.cart_content');
          var $target = $('.cart_content.sidebar_m');

          if (!$freshInner.length || !$target.length) return;

          /* Save scroll positions */
          var targetScroll = $target.scrollTop();
          var $cartItems = $target.find('.js-cart_items');
          var itemsScroll = $cartItems.length ? $cartItems.scrollTop() : 0;

          /* Fade out — adds transition + opacity:0 */
          $target.addClass('cart_content--swapping');

          setTimeout(function() {
            $target.html($freshInner.html());

            /* Restore scroll */
            $target.scrollTop(targetScroll);
            var $newCartItems = $target.find('.js-cart_items');
            if ($newCartItems.length) $newCartItems.scrollTop(itemsScroll);

            /* Swap classes: remove opacity:0, add fade-in transition */
            $target.removeClass('cart_content--swapping');
            $target.addClass('cart_content--fade-in');

            /* Force reflow so transition fires */
            $target[0].offsetHeight;

            /* Clean up fade-in class after transition completes */
            $target.one('transitionend', function() {
              $target.removeClass('cart_content--fade-in');
            });

            if (window.PXUTheme && window.PXUTheme.currency &&
                window.PXUTheme.currency.show_multiple_currencies) {
              window.currencyConverter.convertCurrencies();
            }
            var detail = {
              source: '_fetchCartDrawerSection',
              section: 'cart-drawer',
              drawer: $target[0],
              cartContent: $target[0],
              cartItemsContainer: $newCartItems.length ? $newCartItems[0] : null,
              itemCount: $target.find('.cart_item, .ajax-cart__item, .js-cart-item, [data-cart-item]').length,
              cartTotalText: $.trim($target.find('.cart_total .money, .cart__total .money, [data-cart-total]').first().text() || ''),
              html: $target[0].innerHTML
            };

            document.dispatchEvent(new CustomEvent('cart:drawer:updated', { detail: detail }));
            window.dispatchEvent(new CustomEvent('cart:drawer:updated', { detail: detail }));
          }, 150);
        })
        .catch(function(err) {
          console.warn('Cart section fetch error:', err);
        });
    }
  /* ===================================================================
     End of refreshCart
     =================================================================== */

  /* ===================================================================
     Cart quantity +/- buttons — DELEGATED handler
     ─────────────────────────────────────────
     Must use body delegation because Section Rendering API
     replaces cart drawer HTML on every update.
     Direct bindings from window.cart.init() are lost after swap.
     =================================================================== */

  

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const $input      = $(this);
    const $element    = $input.parents('[data-cart-item]');
    const bundleId    = $element.data('bundle-id');
    const newQty      = parseInt($input.val(), 10);
    const $parentForm = $input.parents('[data-cart-form]');
    $input.attr('data-original-qty', $input.attr('data-original-qty') || newQty);

    $input.parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');

    if (bundleId) {
      updateBundleQuantity(bundleId, newQty, $parentForm, $element);
    } else {
      updateCartItemQuantity({
        lineID:         $element.data('line-id'),
        variantID:      $element.data('variant-id'),
        itemKey:        $element.data('item-key'),
        quantity:       newQty,
        parentCartForm: $parentForm,
        totalDiscount:  $parentForm.data('total-discount'),
        $element
      });
    }
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();

    const $element    = $(this).parents('[data-cart-item]');
    const lineID      = $element.data('line-id');
    const variantID   = $element.data('variant-id');
    const bundleId    = $element.data('bundle-id');
    const $parentForm = $(this).parents('[data-cart-form]');

    if ($parentForm.data('cart-form') === 'cart-template') {
      if (bundleId) {
        $('[data-cart-item][data-bundle-id="' + bundleId + '"]').addClass('animated fadeOutLeft');
        updateBundleQuantity(bundleId, 0, $parentForm, $element);
      } else {
        $element.find('input').val('0');
        updateCartItemQuantity({
          lineID,
          itemKey:       $element.data('item-key'),
          variantID,
          quantity:      0,
          parentCartForm: $parentForm,
          totalDiscount:  $parentForm.data('total-discount'),
          $element
        });
        $parentForm.submit();
      }
      return;
    }

    if (bundleId) {
      $('[data-cart-item][data-bundle-id="' + bundleId + '"]').addClass('animated fadeOutLeft');
      updateBundleQuantity(bundleId, 0, $parentForm, $element);
    } else {
      $element.addClass('animated fadeOutLeft');
      updateCartItemQuantity({
        lineID,
        itemKey:  $element.data('item-key'),
        variantID, quantity: 0,
        parentCartForm: $parentForm,
        totalDiscount:  $parentForm.data('total-discount'),
        $element
      });
      if ($parentForm.data('cart-form') === 'mini-cart') {
        $element.find('input').val('0');
      }
    }
  });

  // ============================================================================
  // AJAX ADD TO CART HANDLER
  // ============================================================================

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault()
      const $addToCartForm = $(this).closest('form')
      const $addToCartBtn = $addToCartForm.find('.add_to_cart')
      const $wrapper = $addToCartForm.closest('[data-product-form]')
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]')
      $('.warning').remove()
      if (this.recipientForm) this.recipientForm.classList.remove('recipient-form--has-errors')

      const runAjax = () => {
        if ($('body').hasClass('cart')) { $addToCartForm.submit(); return }

        // ===== CUSTOM JERSEY INTEGRATION START =====
        let ajaxData = null;
        let contentType = 'application/x-www-form-urlencoded';
        let isCustomJersey = false;

        if ($wrapper.attr('data-custom-jersey') === '1' && window.CustomJerseyWidget) {
          const selectedCustomizations = window.CustomJerseyWidget.getSelectedCustomizations($addToCartForm[0]);

          if (Object.keys(selectedCustomizations).length > 0) {
            const payload = window.CustomJerseyWidget.buildMultiItemPayload($addToCartForm[0], selectedCustomizations);

            if (payload) {
              ajaxData = JSON.stringify(payload);
              contentType = 'application/json';
              isCustomJersey = true;
            }
          }
        }

        if (!ajaxData) {
          ajaxData = $addToCartForm.serialize();
        }

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          contentType: contentType,
          data: ajaxData,
          beforeSend() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled')
            $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut')
          },
          success() {
            $addToCartBtn.find('.checkmark').addClass('checkmark-active')
            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                refreshCart(cart)
                setTimeout(function() {
                  if ($('body').hasClass('fancybox-active')) $.fancybox.close()
                  window.openMiniCart();
                }, 300);

                setTimeout(() => {
                  $addToCartBtn.removeAttr('disabled').removeClass('disabled')
                  $addToCartBtn.find('.checkmark').removeClass('checkmark-active')
                  $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown')
                }, 450);
              }
            })
          },
          error: function(xhr) {
            console.log('Cart add error:', xhr);
            try {
              const response = JSON.parse(xhr.responseText);
              $('.warning').remove()
              let warning
              if (response.errors && response.errors.email) {
                this.recipientForm.classList.add('recipient-form--has-errors')
              } else {
                warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`
                $addToCartForm.after(warning)
              }
            } catch(e) {
              console.error('Error parsing response:', e);
              const warning = `<p class="warning animated bounceIn">Error adding to cart. Please try again.</p>`
              $addToCartForm.after(warning)
            }
            $addToCartBtn.removeAttr('disabled').removeClass('disabled')
            $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn')
          }
        })
      }

      // ===== CUSTOM JERSEY & FINAL SALE MODAL CHECK START =====
      const isCustomizable = $wrapper.attr('data-custom-jersey') === '1';
      const isAlreadyCustomized = $wrapper.attr('data-already-customized') === '1';
      const isFinalSale = $wrapper.attr('data-final-sale') === '1';
      const isExchangeOnly = $wrapper.attr('data-exchange-only') === '1';

      if (isCustomizable && window.CustomJerseyWidget) {
        const validation = window.CustomJerseyWidget.validateSelections($addToCartForm[0]);

        if (!validation.valid) {
          const $widget = $wrapper.find('[data-cj-widget]');
          const $existingError = $widget.find('[data-cj-error]');

          if ($existingError.length) {
            $existingError.remove();
          }

          const errorHtml = `<p class="cj-error-message" data-cj-error style="color: #d32f2f; margin-top: 12px; background: rgba(211, 47, 47, 0.1); border-radius: 4px;">${validation.message}</p>`;
          $widget.append(errorHtml);
          $widget[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

          return false;
        }

        $wrapper.find('[data-cj-error]').remove();
      }

      const hasAddons = isCustomizable
        && window.CustomJerseyWidget
        && window.CustomJerseyWidget.shouldShowModal($addToCartForm[0]);

      let shouldShowModal = false;
      if (isAlreadyCustomized) {
        shouldShowModal = true;
      } else if (isCustomizable) {
        shouldShowModal = hasAddons;
      } else if (isFinalSale) {
        shouldShowModal = true;
      } else if (isExchangeOnly) {
        shouldShowModal = true;
      }

      if (shouldShowModal) {
        const $modal = $wrapper.find('.cj-modal');

        if ($modal.length) {
          // Swap content for already-customized jerseys based on whether shopper added a name/number
          if ($modal.attr('data-modal-variant') === 'already_customized') {
            const $base = $modal.find('[data-cj-content="base"]');
            const $addon = $modal.find('[data-cj-content="addon"]');

            if (hasAddons) {
              $base.attr('hidden', true);
              $addon.attr('hidden', false);
            } else {
              $base.attr('hidden', false);
              $addon.attr('hidden', true);
            }
          }

          // Determine whether the active body wants the checkbox
          let activeBodyShowsCheckbox = false;
          const $activeBody = $modal.find('[data-cj-body]').filter(function() {
            return !$(this).closest('[data-cj-content][hidden]').length;
          }).first();
          if ($activeBody.length) {
            activeBodyShowsCheckbox = $activeBody.attr('data-cj-show-checkbox') === '1';
          }

          const $checkboxWrap = $modal.find('[data-cj-checkbox-wrap]');
          const $confirmCheckbox = $modal.find('[data-cj-confirm-checkbox]');
          const $okBtn = $modal.find('[data-cj-ok]');
          const $cancelBtn = $modal.find('[data-cj-cancel]');
          const $closeBtn = $modal.find('[data-cj-close]');

          // Reset checkbox state each time the modal opens
          $confirmCheckbox.prop('checked', false);

          if (activeBodyShowsCheckbox && $checkboxWrap.length) {
            $checkboxWrap.attr('hidden', false);
            $okBtn.attr('disabled', true).addClass('is-disabled');
          } else {
            $checkboxWrap.attr('hidden', true);
            $okBtn.attr('disabled', false).removeClass('is-disabled');
          }

          $modal.attr('hidden', false);

          const modalPromise = new Promise(resolve => {
            const handleOk = () => {
              if ($okBtn.attr('disabled')) return;
              cleanup();
              resolve(true);
            };

            const handleCancel = () => {
              cleanup();
              resolve(false);
            };

            const handleEscape = (e) => {
              if (e.key === 'Escape') {
                handleCancel();
              }
            };

            const handleCheckboxChange = () => {
              if ($confirmCheckbox.is(':checked')) {
                $okBtn.attr('disabled', false).removeClass('is-disabled');
              } else {
                $okBtn.attr('disabled', true).addClass('is-disabled');
              }
            };

            const cleanup = () => {
              $modal.attr('hidden', true);
              $okBtn.off('click', handleOk);
              $cancelBtn.off('click', handleCancel);
              $closeBtn.off('click', handleCancel);
              $confirmCheckbox.off('change', handleCheckboxChange);
              document.removeEventListener('keydown', handleEscape);
            };

            $okBtn.on('click', handleOk);
            $cancelBtn.on('click', handleCancel);
            $closeBtn.on('click', handleCancel);
            $confirmCheckbox.on('change', handleCheckboxChange);
            document.addEventListener('keydown', handleEscape);

            if (activeBodyShowsCheckbox) {
              $confirmCheckbox.focus();
            } else {
              $okBtn.focus();
            }
          });

          modalPromise.then(confirmed => {
            if (confirmed) {
              runAjax();
            }
          });

          return false;
        }
      }

      // ===== CUSTOM JERSEY & FINAL SALE MODAL CHECK END =====

      runAjax()
      return false
    })
  }

  // ============================================================================
  // END OF AJAX ADD TO CART HANDLER
  // ============================================================================

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;




document.addEventListener('DOMContentLoaded', function () {
    let accordionInitialized = false;

    function initializeAccordion() {
      if (window.innerWidth <= 797 && !accordionInitialized) {
        const accordionHeaders = document.querySelectorAll('.shop-by-club__accordion-header');

        accordionHeaders.forEach((header) => {
          header.addEventListener('click', function () {
            const item = this.parentElement;
            const isOpen = item.classList.contains('open');

            document.querySelectorAll('.shop-by-club__accordion-item').forEach((i) => i.classList.remove('open'));

            if (!isOpen) {
              item.classList.add('open');
            }
          });
        });

        accordionInitialized = true;
      }
    }

    function destroyAccordion() {
      if (window.innerWidth > 797 && accordionInitialized) {
        const items = document.querySelectorAll('.shop-by-club__accordion-item');
        items.forEach((item) => item.classList.remove('open'));
        accordionInitialized = false;
      }
    }

    function handleAccordion() {
      if (window.innerWidth <= 797) {
        initializeAccordion();
      } else {
        destroyAccordion();
      }
    }

    handleAccordion();
    window.addEventListener('resize', function () {
      handleAccordion();
    });
});


document.addEventListener('DOMContentLoaded', function () {

  /* ── Hero Features (mobile-only slider) ── */
  var heroSlider = document.querySelector('.hero-features .swiper-wrapper');
  var flickityHero = null;
  var heroTicker = null;


  /* ── Testimonials Slider ── */
  var testSlider = document.querySelector('#home_testimonials .testimonials-slider');
  if (testSlider) {
    var flkty = jQuery(testSlider).flickity({
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      cellSelector: '.testimonial-cell'
    }).data('flickity');

    var cells = testSlider.querySelectorAll('.testimonial-cell');
    var maxHeight = 0;
    cells.forEach(function(cell) {
      cell.style.height = 'auto';
      if (cell.offsetHeight > maxHeight) maxHeight = cell.offsetHeight;
    });
    cells.forEach(function(cell) { cell.style.height = maxHeight + 'px'; });
    flkty.resize();

    if (testSlider.hasAttribute('data-flickity-ticker')) {
      FlickityTicker.attach(flkty);
    }

    var prevBtn = testSlider.querySelector('.testimonial-arrow--prev');
    var nextBtn = testSlider.querySelector('.testimonial-arrow--next');

    if (prevBtn) prevBtn.addEventListener('click', function() { flkty.previous(true); });
    if (nextBtn) nextBtn.addEventListener('click', function() { flkty.next(true); });
  }

});

